<script>
import { Bar } from "vue-chartjs";
import { apiRequest } from "@/helpers/api-call";

export default {
  props: ['codeparrainage', 'actualYear'], 
  extends: Bar,
  data() {
    return {
      dataGain: null,
      dataNombre: [],
  
      dataMois: [],
      today: new Date(),

      mois: [
        "Jan",
        "Fév",
        "Mar",
        "Avr",
        "Mai",
        "Jui",
        "Juil",
        "Août",
        "Sept",
        "Oct",
        "Nov",
        "Déc",
      ],



    };
  },
  watch: {
    codeparrainage: {
      handler() {
       
        this.loadData();
      },
    },

    actualYear: {
      handler() {
       
        this.loadData();
      },
    },
  },
  async mounted() {
  
  

    this.loadData();
    
  },
  methods: {
    async loadData() {
      this.dataNombre = [];
      this.dataMois = [];

      const stat = await apiRequest(
        "GET",
        "historique/inscrits/"+ this.codeparrainage,
        undefined,
        false
      );

      if (stat && stat.data) {
        var dataStat = stat.data.result;
        this.dataNombre=[]
        this.dataMois=[]
        dataStat.forEach((element) => {
          if (element.annee == this.actualYear) {
            this.dataNombre.push(element.nombreDInscrits);
            this.dataMois.push(this.mois[element.mois - 1]);
          }
        });

        this.renderChart(
          {
            labels: this.dataMois,
            datasets: [
              {
                label: "Inscriptions",
                barPercentage: 0.6,
                backgroundColor: "#89b800",
                borderColor: "#89b800",
                borderWidth: 2,
                shadowOffsetX:-1,
                shadowOffsetY : 1,
                shadowColor :"#79a300",
         
                hoverBackgroundColor: "#89b800",
                hoverBorderColor: "#89b800",
                data: this.dataNombre,
              },
            ],
          },
          {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              xAxes: [
                {
                  gridLines: {
                    color: "rgba(166, 176, 207, 0.1)",
                  },
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    color: "rgba(166, 176, 207, 0.1)",
                  },
                },
              ],
            },
          }
        );
      }
    },
  },
};
</script>


